import {twJoin} from 'tailwind-merge'

import {IconPlaceholderAvatar} from '@sdox/icons/large'
import {LazyImage} from '@sdox/ui'

interface AvatarProps {
  thumbnail?: string | null
}

export const Avatar = (props: AvatarProps) => {
  const {thumbnail} = props

  if (!thumbnail) {
    return (
      <div
        className={twJoin(
          'z-0 mb-spacing-12 size-spacing-96 rounded-full',
          'flex bg-media-bg shrink-0 items-center justify-center',
        )}
      >
        <IconPlaceholderAvatar/>
      </div>
    )
  }

  return (
    <LazyImage
      src={thumbnail}
      className={'z-0 mb-spacing-12 size-spacing-96 rounded-full'}
    />
  )
}
